<template>
  <div class="for-doctors-patients">
    <div class="container">
      <div>

        <div class="row mb-40">
          <div>
            <div v-html="$t('doctorsPatients.bloque1.titulo')" class="title"></div>
            <div class="body-content">
              <div>
                <i class="fas fa-badge-check text-verde"></i>
                <span v-html="$t('doctorsPatients.bloque1.descripcion1')"></span>
              </div>
              <div>
                <i class="fas fa-badge-check text-verde"></i>
                <span v-html="$t('doctorsPatients.bloque1.descripcion2')"></span>
              </div>
              <div class="pt-20"></div>
            </div>
          </div>
          <div class="img-content">
            <img v-if="loaded && getLanguage === 'es'" src="../assets/phone-1-doctors-patients-es.png" alt="">
            <img v-if="loaded && getLanguage !== 'es'" src="../assets/phone-1-doctors-patients-en.png" alt="">
          </div>
        </div>

        <div class="row second-row">
          <div class="img-content second-image">
            <img v-if="loaded && getLanguage === 'es'" src="../assets/phone-2-doctors-patients-es.png" alt="">
            <img v-if="loaded && getLanguage !== 'es'" src="../assets/phone-2-doctors-patients-en.png" alt="">
          </div>
          <div>
            <div v-html="$t('doctorsPatients.bloque2.titulo')" class="title"></div>
            <div class="body-content">
              <div>
                <i class="fas fa-badge-check text-verde"></i>
                <span v-html="$t('doctorsPatients.bloque2.descripcion1')"></span>
              </div>
              <div>
                <i class="fas fa-badge-check text-verde"></i>
                <span v-html="$t('doctorsPatients.bloque2.descripcion2')"></span>
              </div>
              <div>
                <i class="fas fa-badge-check text-verde"></i>
                <span v-html="$t('doctorsPatients.bloque2.descripcion3')"></span>
              </div>
              <div class="pt-20"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../plugins/i18n.js'
export default {
  name: 'ForDoctorsPatient',
  data: () => ({
    loaded: false
  }),
  computed: {
    getLanguage () {
      return i18n.locale
    }
  },
  mounted () {
    this.loaded = true
  }
}
</script>

<style lang="scss" scoped>
.for-doctors-patients {
  width: 100%;
  background: #f7f9ff; /* Old browsers */
  background: -moz-linear-gradient(
    180deg,
    #f7f9ff 0%,
    #f7f9ff 67.19%,
    rgba(247, 249, 255, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    180deg,
    #f7f9ff 0%,
    #f7f9ff 67.19%,
    rgba(247, 249, 255, 0) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    180deg,
    #f7f9ff 0%,
    #f7f9ff 67.19%,
    rgba(247, 249, 255, 0) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    text-align: left;

    .row {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      > div {
        width: 100%;

        .title {
          font-size: 36px;
          font-weight: 700;
          color: #444d67;
          margin-bottom: 45px;
        }

        .body-content {
          width: 100%;

          > div {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            margin-bottom: 30px;

            > i {
              width: 40px;
              font-size: 25px;
            }

            > span {
              width: calc(100% - 40px);
              line-height: 170%;
            }
          }
        }

        &.img-content {
          display: flex;
          align-items: center;
          justify-content: center;

          &.second-image {
            margin-bottom: -100px;
          }
        }
      }
    }
  }

  @media(max-width: 1500px) {
    .second-image img {
      width: 100%;
    }
  }

  @media(max-width: 1380px) {
    .second-row {
      padding-bottom: 55px;
    }
  }

  @media(max-width: 1100px) {
    .container {
      img {
        width: 90%;
      }

      .row > div .title {
        font-size: 32px;
      }

      .second-image img {
        width: 120%;
        margin-left: -95px;
      }
    }
  }

  @media(max-width: 920px) {
    .container .row > div.img-content.second-image {
      margin-bottom: -120px;
    }
  }

  @media(max-width: 900px) {
    .container {
      .row > div .title {
        font-size: 28px;
        margin-bottom: 30px;
      }
      .row:first-of-type > div.img-content img {
        margin-right: -60px;
      }

      .row > div .body-content > div {
        margin-bottom: 20px;

        i {
          font-size: 22px;
        }
      }
    }
  }

  @media(max-width: 825px) {
    .container {
      .row > div .title {
        font-size: 28px;
        margin-bottom: 30px;
      }
      .row > div.img-content {
        width: 60%;

        img {
          width: 120%;
        }
      }

      .row > div .body-content > div {
        margin-bottom: 20px;

        i {
          font-size: 22px;
        }
      }

      .row > div.second-image img {
        width: 160%;
        margin-left: -160px;
      }
    }
  }

  @media(max-width: 770px) {
    .container {
      padding-top: 60px;
      .row {
        flex-direction: column;
      }
      .second-row {
        padding-bottom: 0;

        div:first-child {
          order: 2;

          img {
            margin-left: 0;
          }
        }

        div:last-child {
          order: 1;
        }
      }
    }
  }

  @media(max-width: 630px) {
    .container .row > div.img-content {
      width: 70%;
    }
    .container .row:first-of-type > div.img-content img {
      margin-right: 0px;
    }
    .container .second-row > div.img-content.second-image {
      margin-bottom: -50px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/for-doctors-patients.vue